import React, { SetStateAction } from "react";
import { FaRegEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
const PasswordStatus = ({
  showPassword,
  setShowPassword,
  className,
}: {
  showPassword: boolean;
  setShowPassword: React.Dispatch<SetStateAction<boolean>>;
  className?: string;
}) => {
  return (
    <span
      className={`absolute z-10  cursor-pointer ${className} `}
      onClick={() => {
        setShowPassword((show) => !show);
      }}
    >
      {" "}
      {showPassword ? (
        <FaRegEye className="text-black text-center text-lg " />
      ) : (
        <FaRegEyeSlash className="text-black text-center text-lg " />
      )}
    </span>
  );
};

export default PasswordStatus;
